module.exports = __webpack_public_path__ + "img/d9f8c55eecffb2d87f795ce7ba7caffa.png";